<template>
  <div class="home" id="#app2">
    <DropdownMenuContent />
    <Navbar />
    <DashboardTabs />
  </div>
</template>
<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import firebase from "firebase";
import DropdownMenuContent from "@/components/DropdownMenuContent.vue";
import DashboardTabs from "@/components/DashboardTabs.vue";
import Navbar from "@/components/Navbar.vue";
import M from "materialize-css";
import $ from "jquery";
export default {
  name: "home",
  components: {
    DropdownMenuContent,
    Navbar,
    DashboardTabs
  },
  data() {
    var user = firebase.auth().currentUser;
    return {
      user_name: user.displayName,
      user_email: user.email
    };
  },
  methods: {
    sair: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          location.href = "/";
        });
    },
    dropdown: function() {
      M.Dropdown.init(document.getElementById("dropdown-trigger-user"), {
        isScrollable: true,
        constrainWidth: false
      })._resetDropdownStyles = function() {
        this.$dropdownEl.css({
          display: "",
          width: "400px",
          left: "40px",
          top: "-58px",
          "transform-origin": "",
          transform: "",
          opacity: "",
          height: " 500px",
          "border-radius": "7px"
        });
      };
    }
  },
  mounted() {
    this.dropdown();
    M.Tabs.init($(".tabs"));
    $(".tabs").addClass("tabs-transparent");
  }
};
</script>